"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createGeniusRecord_1 = __importDefault(require("./createGeniusRecord"));
/**
 * Create a record for each genius type from the source.
 * @param table Source.
 * @template T Type of the source.
 */
exports.default = (table) => createGeniusRecord_1.default(table.map((row) => createGeniusRecord_1.default(row)));
//# sourceMappingURL=createGeniusRecords.js.map